import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation UserEvaluation_publish($lessonId: ID!) {
    UserEvaluation_publish(lessonId: $lessonId) {
      status
    }
  }
`;

const UserEvaluationPublish = async ({ lessonId }) =>
  graphql(mutation, {
    lessonId,
  }).then(
    // eslint-disable-next-line camelcase
    ({ UserEvaluation_publish }) => UserEvaluation_publish
  );

export default UserEvaluationPublish;
